import { getApiBaseUrl, getN8NApiBaseUrl } from "./utils/helperFunctions";
const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://d.api.enncrypto.com'
const API_KEY = String(process.env.REACT_APP_API_KEY)
const API_URL = getApiBaseUrl() || 'https://d.api.enncrypto.com';
const N8N_URL = getN8NApiBaseUrl() || 'https://d-workflow.ops.ennteract.com';
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
const SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT || 'dev'
const SENTRY_RELEASE = process.env.REACT_APP_SENTRY_RELEASE || '0.1.0'

const BROCHURE_URL =
  process.env.REACT_APP_BROCHURE_URL ||
  'https://enncrypto-product-overlay.s3.amazonaws.com/pdf/enno-brochure.pdf'

const DEFAULT_OVERLAY =
  process.env.REACT_APP_DEFAULT_OVERLAY ||
  'https://enncrypto-product-overlay.s3.amazonaws.com/blank_overlay.png'

const SER_DEMO = process.env.REACT_APP_SER_DEMO || 'encserial_01'

const POSTHOG_KEY = 'phc_iuCvq8jmB1DfN7ftRngfhzNYEgVDmOXXzj6SZ6Jah2m'
const POSTHOG_API_HOST = 'https://us.i.posthog.com'
const POSTHOG_KEY_PROD = 'phc_MEcapnNBiKACAHUGLebf2MlJ1LYeF26kYvdvL3brpon'
const HALEON_SCAN_ID = process.env.REACT_APP_HALEON_SCAN_ID

const SDK_API_KEY = process.env.REACT_APP_SDK_API_KEY
const SDK_SERVER_BASE_URL = process.env.REACT_APP_SDK_SERVER_BASE_URL
const QR_SERVICE_BASE_URL = process.env.REACT_APP_QR_SERVICE_BASE_URL || "https://d-api.ops.enncrypto.com"

export default {
  BASE_URL,
  API_KEY,
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_RELEASE,
  BROCHURE_URL,
  DEFAULT_OVERLAY,
  SER_DEMO,
  POSTHOG_KEY,
  POSTHOG_API_HOST,
  HALEON_SCAN_ID,
  SDK_API_KEY,
  SDK_SERVER_BASE_URL,
  QR_SERVICE_BASE_URL,
  POSTHOG_KEY_PROD,
  API_URL,
  N8N_URL
}
